module.exports = __webpack_public_path__ + "static/media/blue-box.417a2c1b.png";